import {L10n} from '../../ts/L10n/L10n';
import {ServerUsers} from '../../userManagement/services/resources/ServerUsers';
import {IPersonalAccessToken} from '../../ts/ServerApi/types/IPersonalAccessToken';
import {IResult} from '../../httpClient/serverApi/types/IResponse';
import {ContentActionNotification} from '../../commonInfra/contentActions/ContentActionNotification';
import {Messages} from '../../codegen/Localize';
import {openReactConfirmationDialog} from '../../commonInfra/dialogs/ReactConfirmationDialog';
import {TabDialogWidth} from '../../commonInfra/dialogs/style/TabDialogWidth';
import {IError} from '../../httpClient/serverApi/types/IError';


export function showDeletePersonalAccessTokenActionDialog(token: IPersonalAccessToken, userId: string): Promise<any> {
  const PersonalAccessTokenConfirmDeleteText = Messages.personalAccessTokenConfirmDelete({
    NAME: L10n.elideIfLong(token.clientId)
  });

  const dialogInstance = openReactConfirmationDialog<void, IResult>({
    title: Messages.deleteMessage(),
    message: PersonalAccessTokenConfirmDeleteText,
    paramsForAction: undefined,
    actionName: Messages.deleteMessage(),
    action: () => ServerUsers.instance.deletePersonalAccessToken(userId, token.clientId),
    isActionDelete: true,
    dialogWidth: TabDialogWidth.width375px
  });

  dialogInstance.result.then((result: IResult) => {
    if (result.errors && result.errors.length) {
      const errorMessage = errorMessageFor(result.errors[0]);
      ContentActionNotification.displayFailureToast(errorMessage);
    } else {
      ContentActionNotification.displaySuccessToast(
        Messages.personalAccessTokenDeleteDeviceSuccess({
          NAME: L10n.elideIfLong(token.clientId)
        }));
    }
  });
  return Promise.resolve(dialogInstance.result);
}

function errorMessageFor(error: IError) {
  return Messages.errorUnknown();
}
